module.exports = __webpack_public_path__ + "media/images/prediction/special/img_title_special_prediction-20a09ff714ba6120ff3fdff75f93f071.jpg";